import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["MapView"] */ "/app/packages/frontend/src/app/[locale]/MapView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutButton"] */ "/app/packages/frontend/src/features/auth/LogoutButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultsPanel"] */ "/app/packages/frontend/src/features/items/components/ResultsPanel.tsx");
